import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import type { RankingReport } from '@/queries/cpmRanking';

export function RankingReportLinks({ report, example = false, showVideoUrl = false, videoOnly = false }: { report: RankingReport; example?: boolean; showVideoUrl?: boolean; videoOnly?: boolean }) {
  const { t } = useTranslation();
  return <div className="flex flex-wrap gap-x-3 gap-y-2 text-xs">
    {(videoOnly ? ['video'] as const : ['video', 'profile', 'evidence'] as const).map(key => {
      const url = report[key === 'video' ? 'url' : key === 'profile' ? 'profile_url' : 'evidence_url'];
      return example || !url
        ? <span key={key} aria-disabled="true" className="text-muted-foreground">{t(`ranking.${key}`)}</span>
        : <a key={key} href={url} aria-label={t(`ranking.${key}`)} title={url} target="_blank" rel="noopener noreferrer" className={`inline-flex min-w-0 items-center gap-1 text-blue-400 hover:underline ${showVideoUrl && key === 'video' ? 'w-full' : ''}`}><ExternalLink aria-hidden="true" className="h-3 w-3 shrink-0" /><span className="truncate">{showVideoUrl && key === 'video' ? url : t(`ranking.${key}`)}</span></a>;
    })}
  </div>;
}
